import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { isEqual } from 'lodash';
import makeCancelable, { CanceledError } from 'core/util/cancelablePromise';
import { Flex, Spinner } from 'core/components';
import Model from 'core/model/Model';
import { DEFAULT_WIDGET_CONFIG } from './constants';
import IncidentLog from './IncidentLog';
import IncidentLogMessage from './IncidentLogMessage';

@inject('$syn')
@observer
export default class TestAlerts extends Component {
  static defaultProps = {
    agent: null
  };

  state = {
    loading: true,
    model: new Model(DEFAULT_WIDGET_CONFIG)
  };

  incidentLogRequest = null;

  componentDidMount() {
    this.loadIncidentLogs();
  }

  componentDidUpdate(prevProps, prevState) {
    const { agent } = this.props;
    const { model } = this.state;
    const agentUpdated = prevProps.agent?.id !== agent?.id;
    const selectedTimeChanged = !isEqual(prevState.model.get('selected_time'), model.get('selected_time'));

    if (agentUpdated || selectedTimeChanged) {
      this.loadIncidentLogs();
    }
  }

  componentWillUnmount() {
    if (this.incidentLogRequest) {
      this.incidentLogRequest.cancel();
    }
  }

  handleCancel = (form) => {
    form.reset();
  };

  handleSave = (form) => {
    this.setState({ model: new Model(form.getValues()) });
  };

  get testIds() {
    const { agent } = this.props;
    return (agent?.tests || []).map((test) => test.id.toString());
  }

  loadIncidentLogs = () => {
    const { $syn, agent } = this.props;
    const { model } = this.state;
    const { lookbackSeconds, startDate, endDate } = model.get('selected_time', {});
    if (this.testIds.length > 0) {
      this.setState({ loading: true }, () => {
        this.incidentLogRequest = makeCancelable(
          $syn.tests.loadIncidentLogTestAlarms({ lookbackSeconds, startDate, endDate, ids: this.testIds })
        );

        this.incidentLogRequest.promise
          .then((response) => {
            const { totalAlarms } = response.alarms;

            response.alarms = response.alarms.alarms.filter((alarm) => {
              const { key } = alarm;

              if (!agent) {
                return true;
              }
              // if we are on an agent page, we only want to show alerts for that agent
              if (
                key &&
                key.value &&
                agent &&
                agent.id &&
                (`${key.value.agentId}` === `${agent.id}` || `${key.value.targetAgentId}` === `${agent.id}`)
              ) {
                return true;
              }
              return false;
            });

            return this.setState({
              loading: false,
              alarms: response.alarms,
              totalAlarms
            });
          })
          .catch((err) => {
            if (!(err instanceof CanceledError)) {
              this.setState({ loading: false });
              console.error('Error occurred attempting to load incident log test alerts', err);
            }
          });
      });
    }
  };

  render() {
    const { $syn, agent, minimalTable, ...boxProps } = this.props;
    const { loading, alarms, model, totalAlarms } = this.state;

    if (loading) {
      return (
        <Flex justifyContent="center" {...boxProps}>
          <Spinner />
        </Flex>
      );
    }

    return (
      <>
        <IncidentLogMessage alarms={alarms} totalAlarms={totalAlarms} />
        <IncidentLog
          alarms={alarms}
          model={model}
          totalAlarms={totalAlarms}
          onCancel={this.handleCancel}
          onSave={this.handleSave}
          minimal
          minimalTable={minimalTable}
          {...boxProps}
        />
      </>
    );
  }
}
